<template>
    <landlords-find
        :params="{ landlord: $route.params.landlord }"
        :include="['balance']"
    >
        <div
            slot-scope="{
                data: landlord,
                error,
                is_loading,
                has_loaded,
                find
            }"
            :class="!has_loaded || error ? '' : 'rounded bg-blue bg-gradient-transparent-l-to-black-15a-r shadow mb-6'"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <grid-layout class="m-0">
                    <grid-layout-item class="p-0 w-1/2 md:w-1/3">
                        <div class="relative text-center text-shadow p-3 md:p-6 border-b border-r border-blue-light md:border-b-0">
                            <div class="text-label text-xs text-blue-lighter font-semibold">Pending</div>
                            <div class="text-xl md:text-5xl text-white font-light leading-none">
                                {{ money(landlord.balance.pending).pounds }}<sup class="text-xs md:text-lg">.{{ money(landlord.balance.pending).pence }}</sup>
                            </div>
                            <div class="absolute top-0 right-0 mt-1 mr-1">
                                <base-dropdown placement="bottom-end">
                                    <button
                                        slot="trigger"
                                        slot-scope="{
                                            open
                                        }"
                                        type="button"
                                        class="block rounded-full focus:shadow-outline focus:outline-none"
                                        @click.prevent="open"
                                    >
                                        <base-svg
                                            name="icon-help-circle"
                                            class="w-4 h-4 fill-primary-white fill-secondary-blue-dark"
                                        />
                                    </button>

                                    <div
                                        slot="menu"
                                        class="dropdown-menu max-w-2xs text-sm mt-3px px-2 py-1"
                                    >
                                        Estimated funds pending transfer to your bank account
                                    </div>
                                </base-dropdown>
                            </div>
                        </div>
                    </grid-layout-item>
                    <grid-layout-item class="p-0 w-1/2 md:w-1/3">
                        <div class="relative text-center p-3 md:p-6 border-b border-blue-light md:border-b-0 md:border-r">
                            <div class="text-label text-xs text-blue-lighter font-semibold">Sent</div>
                            <div class="text-xl md:text-5xl text-white font-light leading-none">
                                {{ money(landlord.balance.sent).pounds }}<sup class="text-xs md:text-lg">.{{ money(landlord.balance.sent).pence }}</sup>
                            </div>
                            <div class="absolute top-0 right-0 mt-1 mr-1">
                                <base-dropdown placement="bottom-end">
                                    <button
                                        slot="trigger"
                                        slot-scope="{
                                            open
                                        }"
                                        type="button"
                                        class="block rounded-full focus:shadow-outline focus:outline-none"
                                        @click.prevent="open"
                                    >
                                        <base-svg
                                            name="icon-help-circle"
                                            class="w-4 h-4 fill-primary-white fill-secondary-blue-dark"
                                        />
                                    </button>

                                    <div
                                        slot="menu"
                                        class="dropdown-menu max-w-2xs text-sm mt-3px px-2 py-1"
                                    >
                                        Funds in transit to your bank account
                                    </div>
                                </base-dropdown>
                            </div>
                        </div>
                    </grid-layout-item>
                    <grid-layout-item class="p-0 md:w-1/3">
                        <div class="relative text-center p-3 md:p-6">
                            <div class="text-label text-xs text-blue-lighter font-semibold">Total</div>
                            <div class="text-4xl md:text-5xl text-white font-light leading-none">
                                {{ money(landlord.balance.total).pounds }}<sup class="text-base md:text-lg">.{{ money(landlord.balance.total).pence }}</sup>
                            </div>
                            <div class="absolute top-0 right-0 mt-1 mr-1">
                                <base-dropdown placement="bottom-end">
                                    <button
                                        slot="trigger"
                                        slot-scope="{
                                            open
                                        }"
                                        type="button"
                                        class="block rounded-full focus:shadow-outline focus:outline-none"
                                        @click.prevent="open"
                                    >
                                        <base-svg
                                            name="icon-help-circle"
                                            class="w-4 h-4 fill-primary-white fill-secondary-blue-dark"
                                        />
                                    </button>

                                    <div
                                        slot="menu"
                                        class="dropdown-menu max-w-2xs text-sm mt-3px px-2 py-1"
                                    >
                                        Total funds deposited into your bank account to date
                                    </div>
                                </base-dropdown>
                            </div>
                        </div>
                    </grid-layout-item>
                </grid-layout>
            </template>
        </div>
    </landlords-find>
</template>

<script>
    import _ from 'lodash'
    import LandlordsFind from '../../../../../components/landlords-find'

    export default {
        components: {
            LandlordsFind
        },
        methods: {
            money (value) {
                return _.zipObject(
                    ['pounds', 'pence'],
                    _.chain(value).money().split('.').value()
                )
            }
        }
    }
</script>
